module.exports = __webpack_public_path__ + "static/img/logo-collingwood.d8b821a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-collingwood.svg
// module id = 6njn
// module chunks = 1